/**
 * =============================================================================
 * Componente: ReferralModuleGuard
 * Versão: 2.0.0 (2026-05-04)
 *
 * Descrição:
 *   Wrapper de rotas do módulo Indicação. A partir da v2 o módulo é UNIVERSAL:
 *   todo tenant tem acesso por padrão e a única camada de bloqueio é o gate
 *   de cobrança (`ReferralAccessGate`), que apresenta o paywall quando o
 *   tenant está em tier free com saldo de créditos esgotado.
 *
 *   Histórico:
 *     v1.0.0 — Bloqueava acesso quando `currentTenant.affiliate_enabled = false`
 *              redirecionando para `/tenant`.
 *     v2.0.0 — Removida a flag `affiliate_enabled` (módulo universal). Apenas
 *              envolve children no `ReferralAccessGate` (paywall por créditos).
 * =============================================================================
 */
import { ReactNode } from 'react';
import { ReferralAccessGate } from '@/components/referral/ReferralAccessGate';

interface ReferralModuleGuardProps {
  children: ReactNode;
}

/**
 * Garante que páginas administrativas de Indicação só sejam exibidas quando
 * o tenant tem créditos disponíveis ou está em tier pago. O bloqueio em si
 * é tratado pelo `ReferralAccessGate` que substitui o conteúdo pelo paywall
 * quando `admin_access_blocked = true`.
 */
export function ReferralModuleGuard({ children }: ReferralModuleGuardProps) {
  return <ReferralAccessGate>{children}</ReferralAccessGate>;
}
